import React from "react";
import { Route, Routes } from 'react-router-dom'
import ListPendencies from "../pages/reports/chk-pendencies/ListPendencies";
import EventsDetails from "../pages/reports/events-details/EventsDetails";
import PerformanceRPM from "../pages/reports/performance-rpm/PerformanceRPM";
import Ranking from "../pages/reports/ranking/Ranking";



const ReportsRoute = (props) => {
    return (
        <Routes>
            <Route
                exact
                path={"/report/ranking"}
                element={<Ranking token={props.token} bodyNotify={props.bodyNotify} path={{ get: 'ranking', export: 'ranking/export' }} validateToken={props.validateToken}/>}
            />
            {/* Esta no Arquivo admin.js devido o bug de nao atualizar o componente quando a origem é o mesmo componente
                <Route
                exact
                path="/export/award"
                element={<Ranking token={props.token} bodyNotify={props.bodyNotify} path={{ get: 'award', export: 'award/export' }} validateToken={props.validateToken}/>}
            /> */}
            <Route
                exact
                path="/report/pendencies"
                element={<ListPendencies token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path="/report/events-details"
                element={<EventsDetails token={props.token} bodyNotify={props.bodyNotify} path={{ get: 'award', export: 'award/export' }} validateToken={props.validateToken}/>}
            />
            <Route
                exact
                path="/report/performance-rpm"
                element={<PerformanceRPM token={props.token} bodyNotify={props.bodyNotify} path={{ get: 'award', export: 'award/export' }} validateToken={props.validateToken}/>}
            />
        </Routes>
    )
}

export default ReportsRoute